<template>

    <div class="row">
        <div class="col-md-4 col-md-offset-4">

            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title" v-text="boxTitle"></h2>
                </div>
                <div class="box-body">
                    <div :class="{'form-group':true,'has-error':errors.has('name')}">
                        <label for="name">Team naam:</label>
                        <input
                            type="text"
                            id="name"
                            class="form-control"
                            maxlength="191"
                            v-model="form.name"
                        />
                        <span class="help-block" v-if="errors.has('name')">{{ errors.get('name') }}</span>
                    </div>
                    <div class="form-group text-right">
                        <button
                            class="btn btn-primary"
                            :disabled="!canSubmit"
                            @click="onSubmit"
                        >
                            {{ edit ? 'Wijzigen' : 'Toevoegen' }}
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>

import axios from 'axios';
import Errors from "../../../Errors";

export default {

    computed: {
        canSubmit() {
            return this.loading === false &&
                this.form.name !== '';
        },

        getPostdata() {
            return this.form;
        },

        getRoute() {
            return this.edit === true ?
                this.route('api.v1.hr.teams.update', {id: this.team.id}) :
                this.route('api.v1.hr.teams.store');
        },
    },

    data() {
        return {
            edit:false,
            errors:new Errors,
            form: {
                name:'',
            },
            loading:false,
        }
    },

    methods: {
        getTeamData() {
            this.loading = true;
            axios.get(this.route('api.v1.hr.teams.show', {id: this.team.id}))
                .then(resp => {
                    this.form = resp.data.data;
                    this.loading = false;
                    this.edit = true;
                });
        },

        onSubmit() {
            if (!this.canSubmit) {
                return;
            }
            this.loading = true;
            axios.post(this.getRoute, this.getPostdata)
                .then(resp => {
                    if (resp.data.success) {
                        this.$snotify.success(this.edit ? 'Het team is aangepast' : 'Het team is toegevoegd');
                        this.errors = new Errors;
                        if (!this.edit) {
                            this.$router.push({
                                name:'hr.teams.edit',
                                params: {
                                    id: resp.data.data.team_id,
                                }
                            });
                        }
                    } else {
                        this.$snotify.error('Er is een fout opgetreden bij het ' + (this.edit ? 'aanpassen' : 'toevoegen') + ' van het team.');
                    }
                })
                .catch(err => {
                    this.errors.record(err.response.data.errors);
                    this.$snotify.error("Er zijn fouten in het formulier gevonden");
                })
                .finally(() => this.loading = false);
        }
    },

    mounted() {
        if (this.team) {
            this.getTeamData();
        }
    },

    name:'HrTeamForm',

    props: {
        boxTitle: {
            required:true,
            type:String,
        },
        team: {
            type:Object,
        },
    },

}

</script>
